// default RAW praemien data if server not available

const oVermieter = {"VermRS":{
  "YOLIG":{"SB300":{"B":[{"bis":10000,"minimum":162.04,"promille":0,"von":0},{"bis":16000,"minimum":356.87,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":29.7,"von":16000}],"N":[{"bis":10000,"minimum":162.04,"promille":0,"von":0},{"bis":16000,"minimum":356.87,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":29.7,"von":16000}]},"SB500":{"B":[{"bis":10000,"minimum":137.73,"promille":0,"von":0},{"bis":16000,"minimum":303.35,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":19.3,"von":16000}],"N":[{"bis":10000,"minimum":137.73,"promille":0,"von":0},{"bis":16000,"minimum":303.35,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":19.3,"von":16000}]}},
	"EXP":{"SB300":{"B":[{"bis":10000,"minimum":162.04,"promille":0,"von":0},{"bis":16000,"minimum":356.87,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":29.7,"von":16000}],"N":[{"bis":10000,"minimum":162.04,"promille":0,"von":0},{"bis":16000,"minimum":356.87,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":29.7,"von":16000}]},"SB500":{"B":[{"bis":10000,"minimum":137.73,"promille":0,"von":0},{"bis":16000,"minimum":303.35,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":19.3,"von":16000}],"N":[{"bis":10000,"minimum":137.73,"promille":0,"von":0},{"bis":16000,"minimum":303.35,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":19.3,"von":16000}]}},
	"PRE":{"SB300":{"B":[{"bis":10000,"minimum":162.04,"promille":0,"von":0},{"bis":16000,"minimum":356.87,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":29.7,"von":16000}],"N":[{"bis":10000,"minimum":162.04,"promille":0,"von":0},{"bis":16000,"minimum":356.87,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":29.7,"von":16000}]},"SB500":{"B":[{"bis":10000,"minimum":137.73,"promille":0,"von":0},{"bis":16000,"minimum":303.35,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":19.3,"von":16000}],"N":[{"bis":10000,"minimum":137.73,"promille":0,"von":0},{"bis":16000,"minimum":303.35,"promille":0,"von":10000},{"bis":24000,"minimum":0,"promille":19.3,"von":16000}]}}
  }
};
const objData = {
    "version": "debug2026",
    "Cyber": {
      "EXP": {
        "B": {
          "SB150": {
            "p1": 77.44
          }
        },
        "N": {
          "SB150": {
            "p1": 77.44
          }
        }
      },
      "PRE": {
        "B": {
          "SB150": {
            "p1": 77.44
          }
        },
        "N": {
          "SB150": {
            "p1": 77.44
          }
        }
      },
      "STD": {
        "B": {
          "SB150": {
            "p1": 77.44
          }
        },
        "N": {
          "SB150": {
            "p1": 77.44
          }
        }
      }
    },
    "Fahrer": {
      "EXP": {
        "B": {
          "SB0": {
            "p1": 90.52
          },
          "SB150": {
            "p1": 69.34
          },
          "SB300": {
            "p1": 60.67
          },
          "SB500": {
            "p1": 42.53
          }
        },
        "N": {
          "SB0": {
            "p1": 100.58
          },
          "SB150": {
            "p1": 77.04
          },
          "SB300": {
            "p1": 67.41
          },
          "SB500": {
            "p1": 47.25
          }
        }
      },
      "STD": {
        "B": {
          "SB0": {
            "p1": -1
          },
          "SB150": {
            "p1": 57.78
          },
          "SB300": {
            "p1": 51.04
          },
          "SB500": {
            "p1": -1
          }
        },
        "N": {
          "SB0": {
            "p1": -1
          },
          "SB150": {
            "p1": 64.20
          },
          "SB300": {
            "p1": 56.71
          },
          "SB500": {
            "p1": -1
          }
        }
      }
    },
    "FzRS": {
      "EXP": {
        "B": {
          "SB0": {
            "p1": 124.17
          },
          "SB150": {
            "p1": 94.61
          },
          "SB300": {
            "p1": 79.83
          },
          "SB500": {
            "p1": 57.09
          }
        },
        "N": {
          "SB0": {
            "p1": 137.97
          },
          "SB150": {
            "p1": 105.12
          },
          "SB300": {
            "p1": 88.70
          },
          "SB500": {
            "p1": 63.43
          }
        }
      },
      "STD": {
        "B": {
          "SB0": {
            "p1": 109.78
          },
          "SB150": {
            "p1": 76.08
          },
          "SB300": {
            "p1": 68.37
          },
          "SB500": {
            "p1": -1
          }
        },
        "N": {
          "SB0": {
            "p1": 121.98
          },
          "SB150": {
            "p1": 84.53
          },
          "SB300": {
            "p1": 75.97
          },
          "SB500": {
            "p1": -1
          }
        }
      }
    },
    "P": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 258.94
            },
            "SB150": {
              "p1": 175.48
            },
            "SB300": {
              "p1": 121.98
            },
            "SB500": {
              "p1": 98.70
            }
          },
          "N": {
            "SB0": {
              "p1": 258.94
            },
            "SB150": {
              "p1": 175.48
            },
            "SB300": {
              "p1": 121.98
            },
            "SB500": {
              "p1": 98.70
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 287.83
            },
            "SB150": {
              "p1": 194.74
            },
            "SB300": {
              "p1": 135.89
            },
            "SB500": {
              "p1": 110.25
            }
          },
          "N": {
            "SB0": {
              "p1": 287.83
            },
            "SB150": {
              "p1": 194.74
            },
            "SB300": {
              "p1": 135.89
            },
            "SB500": {
              "p1": 110.25
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 365.94
            },
            "SB150": {
              "p1": 234.33
            },
            "SB300": {
              "p1": 160.50
            },
            "SB500": {
              "p1": 131.25
            }
          },
          "N": {
            "SB0": {
              "p1": 365.94
            },
            "SB150": {
              "p1": 234.33
            },
            "SB300": {
              "p1": 160.50
            },
            "SB500": {
              "p1": 131.25
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 394.83
            },
            "SB150": {
              "p1": 252.52
            },
            "SB300": {
              "p1": 173.34
            },
            "SB500": {
              "p1": 140.70
            }
          },
          "N": {
            "SB0": {
              "p1": 394.83
            },
            "SB150": {
              "p1": 252.52
            },
            "SB300": {
              "p1": 173.34
            },
            "SB500": {
              "p1": 140.70
            }
          }
        }
      }
    },
    "PB": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 421.58
            },
            "SB150": {
              "p1": 266.43
            },
            "SB300": {
              "p1": 211.86
            },
            "SB500": {
              "p1": 176.40
            }
          },
          "N": {
            "SB0": {
              "p1": 421.58
            },
            "SB150": {
              "p1": 266.43
            },
            "SB300": {
              "p1": 211.86
            },
            "SB500": {
              "p1": 176.40
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 468.66
            },
            "SB150": {
              "p1": 295.32
            },
            "SB300": {
              "p1": 234.33
            },
            "SB500": {
              "p1": 195.30
            }
          },
          "N": {
            "SB0": {
              "p1": 468.66
            },
            "SB150": {
              "p1": 295.32
            },
            "SB300": {
              "p1": 234.33
            },
            "SB500": {
              "p1": 195.30
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 520.02
            },
            "SB150": {
              "p1": 332.77
            },
            "SB300": {
              "p1": 273.92
            },
            "SB500": {
              "p1": 214.20
            }
          },
          "N": {
            "SB0": {
              "p1": 520.02
            },
            "SB150": {
              "p1": 332.77
            },
            "SB300": {
              "p1": 273.92
            },
            "SB500": {
              "p1": 214.20
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 564.96
            },
            "SB150": {
              "p1": 361.66
            },
            "SB300": {
              "p1": 298.53
            },
            "SB500": {
              "p1": 233.10
            }
          },
          "N": {
            "SB0": {
              "p1": 564.96
            },
            "SB150": {
              "p1": 361.66
            },
            "SB300": {
              "p1": 298.53
            },
            "SB500": {
              "p1": 233.10
            }
          }
        }
      },
      "STD": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 377.71
            },
            "SB150": {
              "p1": 228.98
            },
            "SB300": {
              "p1": 184.04
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 377.71
            },
            "SB150": {
              "p1": 228.98
            },
            "SB300": {
              "p1": 184.04
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 418.37
            },
            "SB150": {
              "p1": 254.66
            },
            "SB300": {
              "p1": 204.37
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 418.37
            },
            "SB150": {
              "p1": 254.66
            },
            "SB300": {
              "p1": 204.37
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      },
      "YOLIG": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 292.73
            },
            "SB300": {
              "p1": 227.36
            },
            "SB500": {
              "p1": 197.39
            }
          },
          "N": {
            "SB150": {
              "p1": 292.73
            },
            "SB300": {
              "p1": 227.36
            },
            "SB500": {
              "p1": 197.39
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 325.19
            },
            "SB300": {
              "p1": 252.32
            },
            "SB500": {
              "p1": 215.59
            }
          },
          "N": {
            "SB150": {
              "p1": 325.19
            },
            "SB300": {
              "p1": 252.32
            },
            "SB500": {
              "p1": 215.59
            }
          }
        }
      },
      "YOLIR": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 237.11
            },
            "SB300": {
              "p1": 184.16
            },
            "SB500": {
              "p1": 159.88
            }
          },
          "N": {
            "SB150": {
              "p1": 237.11
            },
            "SB300": {
              "p1": 184.16
            },
            "SB500": {
              "p1": 159.88
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 263.41
            },
            "SB300": {
              "p1": 204.37
            },
            "SB500": {
              "p1": 174.63
            }
          },
          "N": {
            "SB150": {
              "p1": 263.41
            },
            "SB300": {
              "p1": 204.37
            },
            "SB500": {
              "p1": 174.63
            }
          }
        }
      }
    },
    "PBV": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 451.71
            },
            "SB150": {
              "p1": 258.49
            },
            "SB300": {
              "p1": 234.36
            },
            "SB500": {
              "p1": 185.63
            }
          },
          "N": {
            "SB0": {
              "p1": 501.90
            },
            "SB150": {
              "p1": 287.21
            },
            "SB300": {
              "p1": 260.40
            },
            "SB500": {
              "p1": 206.25
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 500.85
            },
            "SB150": {
              "p1": 287.21
            },
            "SB300": {
              "p1": 260.82
            },
            "SB500": {
              "p1": 206.25
            }
          },
          "N": {
            "SB0": {
              "p1": 556.50
            },
            "SB150": {
              "p1": 319.12
            },
            "SB300": {
              "p1": 289.80
            },
            "SB500": {
              "p1": 229.17
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 526.37
            },
            "SB150": {
              "p1": 329.97
            },
            "SB300": {
              "p1": 284.81
            },
            "SB500": {
              "p1": 221.66
            }
          },
          "N": {
            "SB0": {
              "p1": 584.85
            },
            "SB150": {
              "p1": 366.63
            },
            "SB300": {
              "p1": 316.46
            },
            "SB500": {
              "p1": 246.29
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 573.62
            },
            "SB150": {
              "p1": 359.28
            },
            "SB300": {
              "p1": 311.42
            },
            "SB500": {
              "p1": 242.42
            }
          },
          "N": {
            "SB0": {
              "p1": 637.35
            },
            "SB150": {
              "p1": 399.20
            },
            "SB300": {
              "p1": 346.02
            },
            "SB500": {
              "p1": 269.35
            }
          }
        }
      },
      "STD": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 415.06
            },
            "SB150": {
              "p1": 242.85
            },
            "SB300": {
              "p1": 208.02
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 461.18
            },
            "SB150": {
              "p1": 269.83
            },
            "SB300": {
              "p1": 231.13
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 460.53
            },
            "SB150": {
              "p1": 269.94
            },
            "SB300": {
              "p1": 231.24
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 511.70
            },
            "SB150": {
              "p1": 299.93
            },
            "SB300": {
              "p1": 256.93
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      },
      "YOLIG": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 301.66
            },
            "SB300": {
              "p1": 270.97
            },
            "SB500": {
              "p1": 215.62
            }
          },
          "N": {
            "SB150": {
              "p1": 301.66
            },
            "SB300": {
              "p1": 270.97
            },
            "SB500": {
              "p1": 215.62
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 335.20
            },
            "SB300": {
              "p1": 300.76
            },
            "SB500": {
              "p1": 239.32
            }
          },
          "N": {
            "SB150": {
              "p1": 335.20
            },
            "SB300": {
              "p1": 300.76
            },
            "SB500": {
              "p1": 239.32
            }
          }
        }
      },
      "YOLIR": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 253.40
            },
            "SB300": {
              "p1": 227.62
            },
            "SB500": {
              "p1": 181.12
            }
          },
          "N": {
            "SB150": {
              "p1": 253.40
            },
            "SB300": {
              "p1": 227.62
            },
            "SB500": {
              "p1": 181.12
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 281.57
            },
            "SB300": {
              "p1": 252.64
            },
            "SB500": {
              "p1": 201.03
            }
          },
          "N": {
            "SB150": {
              "p1": 281.57
            },
            "SB300": {
              "p1": 252.64
            },
            "SB500": {
              "p1": 201.03
            }
          }
        }
      }
    },
    "PBVW": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 520.34
            },
            "SB150": {
              "p1": 319.23
            },
            "SB300": {
              "p1": 243.18
            },
            "SB500": {
              "p1": 200.79
            }
          },
          "N": {
            "SB0": {
              "p1": 578.16
            },
            "SB150": {
              "p1": 354.70
            },
            "SB300": {
              "p1": 270.20
            },
            "SB500": {
              "p1": 223.10
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 577.50
            },
            "SB150": {
              "p1": 353.75
            },
            "SB300": {
              "p1": 269.37
            },
            "SB500": {
              "p1": 222.78
            }
          },
          "N": {
            "SB0": {
              "p1": 641.67
            },
            "SB150": {
              "p1": 393.05
            },
            "SB300": {
              "p1": 299.30
            },
            "SB500": {
              "p1": 247.53
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 609.53
            },
            "SB150": {
              "p1": 367.18
            },
            "SB300": {
              "p1": 294.91
            },
            "SB500": {
              "p1": 234.77
            }
          },
          "N": {
            "SB0": {
              "p1": 677.25
            },
            "SB150": {
              "p1": 407.98
            },
            "SB300": {
              "p1": 327.68
            },
            "SB500": {
              "p1": 260.86
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 664.68
            },
            "SB150": {
              "p1": 400.56
            },
            "SB300": {
              "p1": 323.24
            },
            "SB500": {
              "p1": 256.73
            }
          },
          "N": {
            "SB0": {
              "p1": 738.53
            },
            "SB150": {
              "p1": 445.07
            },
            "SB300": {
              "p1": 359.15
            },
            "SB500": {
              "p1": 285.25
            }
          }
        }
      },
      "STD": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 486.84
            },
            "SB150": {
              "p1": 274.67
            },
            "SB300": {
              "p1": 216.81
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 540.93
            },
            "SB150": {
              "p1": 305.19
            },
            "SB300": {
              "p1": 240.90
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 541.04
            },
            "SB150": {
              "p1": 305.19
            },
            "SB300": {
              "p1": 241.45
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 601.16
            },
            "SB150": {
              "p1": 339.10
            },
            "SB300": {
              "p1": 268.28
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      },
      "YOLIG": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 357.01
            },
            "SB300": {
              "p1": 297.32
            },
            "SB500": {
              "p1": 230.08
            }
          },
          "N": {
            "SB150": {
              "p1": 357.01
            },
            "SB300": {
              "p1": 297.32
            },
            "SB500": {
              "p1": 230.08
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 395.09
            },
            "SB300": {
              "p1": 330.36
            },
            "SB500": {
              "p1": 259.22
            }
          },
          "N": {
            "SB150": {
              "p1": 395.09
            },
            "SB300": {
              "p1": 330.36
            },
            "SB500": {
              "p1": 259.22
            }
          }
        }
      },
      "YOLIR": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 317.74
            },
            "SB300": {
              "p1": 264.62
            },
            "SB500": {
              "p1": 204.76
            }
          },
          "N": {
            "SB150": {
              "p1": 317.74
            },
            "SB300": {
              "p1": 264.62
            },
            "SB500": {
              "p1": 204.76
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 351.63
            },
            "SB300": {
              "p1": 294.01
            },
            "SB500": {
              "p1": 230.71
            }
          },
          "N": {
            "SB150": {
              "p1": 351.63
            },
            "SB300": {
              "p1": 294.01
            },
            "SB500": {
              "p1": 230.71
            }
          }
        }
      }
    },
    "PBW": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 440.84
            },
            "SB150": {
              "p1": 296.61
            },
            "SB300": {
              "p1": 249.31
            },
            "SB500": {
              "p1": 190.05
            }
          },
          "N": {
            "SB0": {
              "p1": 440.84
            },
            "SB150": {
              "p1": 296.61
            },
            "SB300": {
              "p1": 249.31
            },
            "SB500": {
              "p1": 190.05
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 488.99
            },
            "SB150": {
              "p1": 329.22
            },
            "SB300": {
              "p1": 277.13
            },
            "SB500": {
              "p1": 211.05
            }
          },
          "N": {
            "SB0": {
              "p1": 488.99
            },
            "SB150": {
              "p1": 329.22
            },
            "SB300": {
              "p1": 277.13
            },
            "SB500": {
              "p1": 211.05
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 546.77
            },
            "SB150": {
              "p1": 358.56
            },
            "SB300": {
              "p1": 292.37
            },
            "SB500": {
              "p1": 236.50
            }
          },
          "N": {
            "SB0": {
              "p1": 546.77
            },
            "SB150": {
              "p1": 358.56
            },
            "SB300": {
              "p1": 292.37
            },
            "SB500": {
              "p1": 236.50
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 594.92
            },
            "SB150": {
              "p1": 390.39
            },
            "SB300": {
              "p1": 318.65
            },
            "SB500": {
              "p1": 259.08
            }
          },
          "N": {
            "SB0": {
              "p1": 594.92
            },
            "SB150": {
              "p1": 390.39
            },
            "SB300": {
              "p1": 318.65
            },
            "SB500": {
              "p1": 259.08
            }
          }
        }
      },
      "STD": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 427.05
            },
            "SB150": {
              "p1": 261.20
            },
            "SB300": {
              "p1": 212.43
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 427.05
            },
            "SB150": {
              "p1": 261.20
            },
            "SB300": {
              "p1": 212.43
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 474.14
            },
            "SB150": {
              "p1": 289.15
            },
            "SB300": {
              "p1": 235.43
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 474.14
            },
            "SB150": {
              "p1": 289.15
            },
            "SB300": {
              "p1": 235.43
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      },
      "YOLIG": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 320.02
            },
            "SB300": {
              "p1": 263.61
            },
            "SB500": {
              "p1": 213.17
            }
          },
          "N": {
            "SB150": {
              "p1": 320.02
            },
            "SB300": {
              "p1": 263.61
            },
            "SB500": {
              "p1": 213.17
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 355.17
            },
            "SB300": {
              "p1": 292.90
            },
            "SB500": {
              "p1": 236.60
            }
          },
          "N": {
            "SB150": {
              "p1": 355.17
            },
            "SB300": {
              "p1": 292.90
            },
            "SB500": {
              "p1": 236.60
            }
          }
        }
      },
      "YOLIR": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 275.21
            },
            "SB300": {
              "p1": 226.71
            },
            "SB500": {
              "p1": 183.32
            }
          },
          "N": {
            "SB150": {
              "p1": 275.21
            },
            "SB300": {
              "p1": 226.71
            },
            "SB500": {
              "p1": 183.32
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 305.45
            },
            "SB300": {
              "p1": 251.89
            },
            "SB500": {
              "p1": 203.48
            }
          },
          "N": {
            "SB150": {
              "p1": 305.45
            },
            "SB300": {
              "p1": 251.89
            },
            "SB500": {
              "p1": 203.48
            }
          }
        }
      }
    },
    "PV": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 333.20
            },
            "SB150": {
              "p1": 216.68
            },
            "SB300": {
              "p1": 164.67
            },
            "SB500": {
              "p1": 120.96
            }
          },
          "N": {
            "SB0": {
              "p1": 370.22
            },
            "SB150": {
              "p1": 240.75
            },
            "SB300": {
              "p1": 182.97
            },
            "SB500": {
              "p1": 134.40
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 369.79
            },
            "SB150": {
              "p1": 240.75
            },
            "SB300": {
              "p1": 182.97
            },
            "SB500": {
              "p1": 134.19
            }
          },
          "N": {
            "SB0": {
              "p1": 410.88
            },
            "SB150": {
              "p1": 267.50
            },
            "SB300": {
              "p1": 203.30
            },
            "SB500": {
              "p1": 149.10
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 436.24
            },
            "SB150": {
              "p1": 285.05
            },
            "SB300": {
              "p1": 203.19
            },
            "SB500": {
              "p1": 152.15
            }
          },
          "N": {
            "SB0": {
              "p1": 484.71
            },
            "SB150": {
              "p1": 316.72
            },
            "SB300": {
              "p1": 225.77
            },
            "SB500": {
              "p1": 169.05
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 472.83
            },
            "SB150": {
              "p1": 308.16
            },
            "SB300": {
              "p1": 221.49
            },
            "SB500": {
              "p1": 165.38
            }
          },
          "N": {
            "SB0": {
              "p1": 525.37
            },
            "SB150": {
              "p1": 342.40
            },
            "SB300": {
              "p1": 246.10
            },
            "SB500": {
              "p1": 183.75
            }
          }
        }
      },
      "STD": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 279.27
            },
            "SB150": {
              "p1": 182.01
            },
            "SB300": {
              "p1": 134.82
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 310.30
            },
            "SB150": {
              "p1": 202.23
            },
            "SB300": {
              "p1": 149.80
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 309.12
            },
            "SB150": {
              "p1": 202.23
            },
            "SB300": {
              "p1": 150.23
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 343.47
            },
            "SB150": {
              "p1": 224.70
            },
            "SB300": {
              "p1": 166.92
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      },
      "YOLIG": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 228.28
            },
            "SB300": {
              "p1": 177.22
            },
            "SB500": {
              "p1": 137.57
            }
          },
          "N": {
            "SB150": {
              "p1": 228.28
            },
            "SB300": {
              "p1": 177.22
            },
            "SB500": {
              "p1": 137.57
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 256.94
            },
            "SB300": {
              "p1": 197.00
            },
            "SB500": {
              "p1": 151.79
            }
          },
          "N": {
            "SB150": {
              "p1": 256.94
            },
            "SB300": {
              "p1": 197.00
            },
            "SB500": {
              "p1": 151.79
            }
          }
        }
      }
    },
    "PVW": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 393.87
            },
            "SB150": {
              "p1": 258.35
            },
            "SB300": {
              "p1": 208.01
            },
            "SB500": {
              "p1": 153.09
            }
          },
          "N": {
            "SB0": {
              "p1": 437.63
            },
            "SB150": {
              "p1": 287.06
            },
            "SB300": {
              "p1": 231.12
            },
            "SB500": {
              "p1": 170.10
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 437.20
            },
            "SB150": {
              "p1": 287.16
            },
            "SB300": {
              "p1": 231.12
            },
            "SB500": {
              "p1": 170.10
            }
          },
          "N": {
            "SB0": {
              "p1": 485.78
            },
            "SB150": {
              "p1": 319.07
            },
            "SB300": {
              "p1": 256.80
            },
            "SB500": {
              "p1": 189.00
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 485.35
            },
            "SB150": {
              "p1": 322.94
            },
            "SB300": {
              "p1": 241.45
            },
            "SB500": {
              "p1": 185.76
            }
          },
          "N": {
            "SB0": {
              "p1": 539.28
            },
            "SB150": {
              "p1": 358.82
            },
            "SB300": {
              "p1": 268.28
            },
            "SB500": {
              "p1": 206.40
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 527.72
            },
            "SB150": {
              "p1": 350.25
            },
            "SB300": {
              "p1": 262.14
            },
            "SB500": {
              "p1": 202.21
            }
          },
          "N": {
            "SB0": {
              "p1": 586.36
            },
            "SB150": {
              "p1": 389.17
            },
            "SB300": {
              "p1": 291.27
            },
            "SB500": {
              "p1": 224.68
            }
          }
        }
      },
      "STD": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 344.93
            },
            "SB150": {
              "p1": 238.49
            },
            "SB300": {
              "p1": 183.30
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 383.25
            },
            "SB150": {
              "p1": 264.99
            },
            "SB300": {
              "p1": 203.67
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 383.36
            },
            "SB150": {
              "p1": 265.10
            },
            "SB300": {
              "p1": 203.01
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 425.96
            },
            "SB150": {
              "p1": 294.56
            },
            "SB300": {
              "p1": 225.57
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      },
      "YOLIG": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": 292.60
            },
            "SB300": {
              "p1": 228.18
            },
            "SB500": {
              "p1": 172.31
            }
          },
          "N": {
            "SB150": {
              "p1": 292.60
            },
            "SB300": {
              "p1": 228.18
            },
            "SB500": {
              "p1": 172.31
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": 324.71
            },
            "SB300": {
              "p1": 254.22
            },
            "SB500": {
              "p1": 191.25
            }
          },
          "N": {
            "SB150": {
              "p1": 324.71
            },
            "SB300": {
              "p1": 254.22
            },
            "SB500": {
              "p1": 191.25
            }
          }
        }
      }
    },
    "PW": {
      "EXP": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 342.40
            },
            "SB150": {
              "p1": 230.87
            },
            "SB300": {
              "p1": 164.78
            },
            "SB500": {
              "p1": 129.15
            }
          },
          "N": {
            "SB0": {
              "p1": 342.40
            },
            "SB150": {
              "p1": 230.87
            },
            "SB300": {
              "p1": 164.78
            },
            "SB500": {
              "p1": 129.15
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 379.85
            },
            "SB150": {
              "p1": 256.17
            },
            "SB300": {
              "p1": 182.97
            },
            "SB500": {
              "p1": 142.80
            }
          },
          "N": {
            "SB0": {
              "p1": 379.85
            },
            "SB150": {
              "p1": 256.17
            },
            "SB300": {
              "p1": 182.97
            },
            "SB500": {
              "p1": 142.80
            }
          }
        }
      },
      "PRE": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 452.61
            },
            "SB150": {
              "p1": 272.03
            },
            "SB300": {
              "p1": 199.02
            },
            "SB500": {
              "p1": 156.45
            }
          },
          "N": {
            "SB0": {
              "p1": 452.61
            },
            "SB150": {
              "p1": 272.03
            },
            "SB300": {
              "p1": 199.02
            },
            "SB500": {
              "p1": 156.45
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 490.06
            },
            "SB150": {
              "p1": 295.05
            },
            "SB300": {
              "p1": 216.14
            },
            "SB500": {
              "p1": 169.05
            }
          },
          "N": {
            "SB0": {
              "p1": 490.06
            },
            "SB150": {
              "p1": 295.05
            },
            "SB300": {
              "p1": 216.14
            },
            "SB500": {
              "p1": 169.05
            }
          }
        }
      },
      "STD": {
        "EPH": {
          "B": {
            "SB0": {
              "p1": 287.83
            },
            "SB150": {
              "p1": 179.42
            },
            "SB300": {
              "p1": 133.75
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 287.83
            },
            "SB150": {
              "p1": 179.42
            },
            "SB300": {
              "p1": 133.75
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB0": {
              "p1": 319.93
            },
            "SB150": {
              "p1": 199.13
            },
            "SB300": {
              "p1": 148.73
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB0": {
              "p1": 319.93
            },
            "SB150": {
              "p1": 199.13
            },
            "SB300": {
              "p1": 148.73
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      },
      "YOLIG": {
        "EPH": {
          "B": {
            "SB150": {
              "p1": -1
            },
            "SB300": {
              "p1": -1
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB150": {
              "p1": -1
            },
            "SB300": {
              "p1": -1
            },
            "SB500": {
              "p1": -1
            }
          }
        },
        "MPH": {
          "B": {
            "SB150": {
              "p1": -1
            },
            "SB300": {
              "p1": -1
            },
            "SB500": {
              "p1": -1
            }
          },
          "N": {
            "SB150": {
              "p1": -1
            },
            "SB300": {
              "p1": -1
            },
            "SB500": {
              "p1": -1
            }
          }
        }
      }
    },
    "S&S PBVW+SSR": {
      "EXP": {
        "EPH": {
          "N": {
            "SB300": {
              "p1": 293.00
            }
          }
        },
        "MPH": {
          "N": {
            "SB300": {
              "p1": 293.00
            }
          }
        }
      }
    },
    "SSR": {
      "EXP": {
        "B": {
          "SB0": {
            "p1": 72.60
          },
          "SB150": {
            "p1": 57.36
          },
          "SB300": {
            "p1": 35.02
          },
          "SB500": {
            "p1": 29.77
          }
        },
        "N": {
          "SB0": {
            "p1": 72.60
          },
          "SB150": {
            "p1": 57.36
          },
          "SB300": {
            "p1": 35.02
          },
          "SB500": {
            "p1": 29.77
          }
        }
      },
      "PRE": {
        "B": {
          "SB0": {
            "p1": 72.60
          },
          "SB150": {
            "p1": 57.36
          },
          "SB300": {
            "p1": 35.02
          },
          "SB500": {
            "p1": 29.77
          }
        },
        "N": {
          "SB0": {
            "p1": 72.60
          },
          "SB150": {
            "p1": 57.36
          },
          "SB300": {
            "p1": 35.02
          },
          "SB500": {
            "p1": 29.77
          }
        }
      },
      "YOLIG": {
        "B": {
          "SB0": {
            "p1": 72.60
          },
          "SB150": {
            "p1": 57.36
          },
          "SB300": {
            "p1": 35.02
          },
          "SB500": {
            "p1": 29.77
          }
        },
        "N": {
          "SB0": {
            "p1": 72.60
          },
          "SB150": {
            "p1": 57.36
          },
          "SB300": {
            "p1": 35.02
          },
          "SB500": {
            "p1": 29.77
          }
        }
      }
    },
    "V-Familie": {
      "EXP": {
        "B": {
          "SB0": {
            "p1": 208.01
          },
          "SB150": {
            "p1": 146.38
          },
          "SB300": {
            "p1": 134.82
          },
          "SB500": {
            "p1": 94.50
          }
        },
        "N": {
          "SB0": {
            "p1": 231.12
          },
          "SB150": {
            "p1": 162.64
          },
          "SB300": {
            "p1": 149.80
          },
          "SB500": {
            "p1": 105.00
          }
        }
      },
      "STD": {
        "B": {
          "SB0": {
            "p1": 185.86
          },
          "SB150": {
            "p1": 127.12
          },
          "SB300": {
            "p1": 110.75
          },
          "SB500": {
            "p1": -1
          }
        },
        "N": {
          "SB0": {
            "p1": 206.51
          },
          "SB150": {
            "p1": 141.24
          },
          "SB300": {
            "p1": 123.05
          },
          "SB500": {
            "p1": -1
          }
        }
      }
    },
    "V-VN": {
      "EXP": {
        "B": {
          "SB0": {
            "p1": 140.11
          },
          "SB150": {
            "p1": 103.04
          },
          "SB300": {
            "p1": 89.56
          },
          "SB500": {
            "p1": 64.26
          }
        },
        "N": {
          "SB0": {
            "p1": 155.68
          },
          "SB150": {
            "p1": 114.49
          },
          "SB300": {
            "p1": 99.51
          },
          "SB500": {
            "p1": 71.40
          }
        }
      },
      "STD": {
        "B": {
          "SB0": {
            "p1": 116.52
          },
          "SB150": {
            "p1": 85.71
          },
          "SB300": {
            "p1": 75.11
          },
          "SB500": {
            "p1": -1
          }
        },
        "N": {
          "SB0": {
            "p1": 129.47
          },
          "SB150": {
            "p1": 95.23
          },
          "SB300": {
            "p1": 83.46
          },
          "SB500": {
            "p1": -1
          }
        }
      }
    },
    "VermRS": {
      "EXP": {
        "B": {
          "": {
            "p1": 28.3
          }
        },
        "N": {
          "": {
            "p1": 28.3
          }
        }
      },
      "PRE": {
        "B": {
          "": {
            "p1": 28.3
          }
        },
        "N": {
          "": {
            "p1": 28.3
          }
        }
      },
      "YOLIG": {
        "B": {
          "": {
            "p1": 28.3
          }
        },
        "N": {
          "": {
            "p1": 28.3
          }
        }
      }
    },
    "zus. HWRS": {
      "EXP": {
        "B": {
          "SB0": {
            "p1": 95.27
          },
          "SB150": {
            "p1": 57.80
          },
          "SB300": {
            "p1": 45.38
          },
          "SB500": {
            "p1": 36.31
          }
        },
        "N": {
          "SB0": {
            "p1": 95.27
          },
          "SB150": {
            "p1": 57.80
          },
          "SB300": {
            "p1": 45.38
          },
          "SB500": {
            "p1": 36.31
          }
        }
      },
      "YOLIG": {
        "B": {
          "SB0": {
            "p1": 95.27
          },
          "SB150": {
            "p1": 57.80
          },
          "SB300": {
            "p1": 45.38
          },
          "SB500": {
            "p1": 36.31
          }
        },
        "N": {
          "SB0": {
            "p1": 95.27
          },
          "SB150": {
            "p1": 57.80
          },
          "SB300": {
            "p1": 45.38
          },
          "SB500": {
            "p1": 36.31
          }
        }
      }
    }
  }
;
    
export default {
  praemien: objData,
  praemienvermieter: oVermieter
};
